import useBcSelectedStore from '@/frontapp/store/bcSelected'
import { trackEvent } from '../gtm' 

export default {
  methods: {
    click(action) {
      this.$store.commit('nette/updateControl', {
        controlName: 'copyForm',
        data: true,
        key: 'showModal'
      })
      trackEvent(this.$route.matched[0].name, 'showCopyForm')
      this.$formValues['frm-copyForm-copyForm-action:change'] = action
    },
    folderClick(action) {
      const bcSelectedStore = useBcSelectedStore()
      bcSelectedStore.resetSelected()
      bcSelectedStore.select(this.item)
      this.$store.commit('nette/updateControl', {
        controlName: 'copyForm',
        data: true,
        key: 'showModal'
      })
      this.$formValues['frm-copyForm-copyForm-action:change'] = action
      this.$emit('onselect')
    },
  }
}